import { useEffect, useState } from "react";

const PROXY_URL = "https://aiclock-proxy.herokuapp.com";

const getEndDate = (data) => {
  if (!data) {
    return null;
  }

  const question = data.question;
  const aggregations = data.aggregations || question.aggregations;

  const normedMedian = aggregations.recency_weighted.latest.centers[0];
  const ratio = question.possibilities.scale.deriv_ratio;

  let startDate, endDate;

  // For linear scale (ratio = 1), use continuous_range if available
  // as it represents the actual prediction range
  if (ratio === 1 && question.scaling?.continuous_range) {
    const range = question.scaling.continuous_range;
    startDate = new Date(range[0]);
    endDate = new Date(range[range.length - 1]);
  } else {
    startDate = new Date(question.possibilities.scale.min);
    endDate = new Date(question.possibilities.scale.max);
  }

  const width = endDate.getTime() - startDate.getTime();

  const denormedMedian =
    ratio !== 1 ? (ratio ** normedMedian - 1) / (ratio - 1) : normedMedian;

  const result = new Date(startDate.getTime() + width * denormedMedian);

  return result;
};

const useFetchEndDate = () => {
  const [data, setData] = useState();
  const isStrong = localStorage.getItem("strong-ai") === "true";

  useEffect(() => {
    // Clear old data when switching between question types
    setData(null);

    const fetchQuestion = () => {
      const url = isStrong ? `${PROXY_URL}/strong` : PROXY_URL;
      fetch(url)
        .then((res) => res.json())
        .then(
          (result) => {
            setData(result);
          },
          (error) => {
            console.error("Failed to fetch AGI prediction:", error);
          }
        );
    };

    fetchQuestion();

    const interval = setInterval(fetchQuestion, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, [isStrong]);

  return getEndDate(data);
};

export default useFetchEndDate;
